import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { login } from "../lib/adminApi";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const inputCls =
    "w-full px-4 py-3 rounded-xl bg-white border border-[#BCBFCC] text-[#1E1E24] placeholder:text-[#9DA2B3] focus:outline-none focus:ring-2 focus:ring-[#0262B4] focus:border-transparent transition-all";

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Enter your email and password.");
      return;
    }
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#EDEFF7] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src="/logo-communitytax.webp" alt="Community Tax" className="h-8 w-auto" />
        </div>
        <div className="bg-white rounded-[24px] ct-shadow-card p-8 lg:p-10" data-testid="admin-login-card">
          <div className="w-12 h-12 rounded-2xl ct-grad-navy flex items-center justify-center mb-5">
            <Lock className="w-6 h-6 text-white" strokeWidth={1.75} />
          </div>
          <h1 className="font-display text-2xl font-bold text-[#1E1E24] mb-1">Partner Admin</h1>
          <p className="text-[#40424D] text-base mb-8">Sign in to view partner applications.</p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-sm font-bold text-[#1E1E24] mb-2">Email</label>
              <input
                type="email"
                className={inputCls}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@communitytax.com"
                data-testid="admin-email"
              />
            </div>
            <div>
              <label className="block text-sm font-bold text-[#1E1E24] mb-2">Password</label>
              <input
                type="password"
                className={inputCls}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full ct-grad-navy-btn text-white font-semibold transition-all hover:-translate-y-0.5 disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
